<div class="validation-error-text"
     *ngIf="(text && formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)) || textWarning"
     aria-live="assertive">
  <span [class.validation-error-text_text]="text" [class.validation-error-text_text-warning]="textWarning">
    {{text || textWarning | translate}}
  </span>
</div>
